// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import setReorderPadFilterQuery from "@keller/App/Handlers/ReorderPad/SetReorderPadFilterQuery";
import { CustomAppState, ReorderPadProductFilters } from "@keller/App/Store/Reducers";
import cloneDeep from "lodash/cloneDeep";

type HandlerType = HandlerWithResult<ReorderPadProductFilters, ReorderPadProductFilters>;

export const GetCurrentFilters: HandlerType = props => {
    props.result = cloneDeep((props.getState() as CustomAppState).xReorderPad.productFilters);
};

export const ResetPage: HandlerType = props => {
    if (props.parameter.pageSize || props.parameter.sort || props.parameter.searchWithin?.length) {
        props.result.page = undefined;
    }
};

export const RemoveSearchWithin: HandlerType = props => {
    props.result.searchWithin = props.result.searchWithin?.filter(x => !props.parameter.searchWithin?.includes(x));
    if (props.result.searchWithin?.length === 0) {
        props.result.searchWithin = undefined;
    }
};

export const RemoveFromDate: HandlerType = ({ result, parameter: { fromDate } }) => {
    if (fromDate !== undefined) {
        result.fromDate = undefined;
    }
};

export const RemoveToDate: HandlerType = ({ result, parameter: { toDate } }) => {
    if (toDate !== undefined) {
        result.toDate = undefined;
    }
};

export const DispatchSetProductFilters: HandlerType = props => {
    props.dispatch({
        type: "xReorderPad/SetProductFilters" as any,
        result: props.result,
    });
};

export const DispatchSetFilterQuery: HandlerType = props => {
    props.dispatch(setReorderPadFilterQuery());
};

export const chain = [
    GetCurrentFilters,
    ResetPage,
    RemoveSearchWithin,
    RemoveFromDate,
    RemoveToDate,
    DispatchSetProductFilters,
    DispatchSetFilterQuery,
];

const removeReorderPadFilters = createHandlerChainRunner(chain, "RemoveProductFilters");
export default removeReorderPadFilters;
